import { useSendOtp } from "@repo/lib/hooks/account";
import { useEffect, useState } from "react";

const useResendOTP = (formValues, initialTime = 180) => {
  const { isPending: isPendingGetOTP, handleSendOtp } = useSendOtp(formValues);
  const [timer, setTimer] = useState(initialTime);
  const [isResendDisabled, setIsResendDisabled] = useState(true);

  // Format the timer into minutes:seconds
  const formattedTimer = `${Math.floor(timer / 60)}:${String(timer % 60).padStart(2, "0")}m`;

  useEffect(() => {
    let countdown;
    if (isResendDisabled && timer > 0) {
      countdown = setInterval(() => {
        setTimer((prevTime) => prevTime - 1);
      }, 1000);
    }

    if (timer === 0) {
      setIsResendDisabled(false);
    }

    return () => {
      clearInterval(countdown);
    };
  }, [timer, isResendDisabled]);

  const handleResend = (e) => {
    setIsResendDisabled(true);
    setTimer(initialTime); // Reset the timer
    // Sending event and true value to identify the event is fired from resend otp button
    handleSendOtp(e, true);
  };

  return {
    timer: formattedTimer,
    isResendDisabled,
    setTimer,
    setIsResendDisabled,
    handleResend,
    isPendingGetOTP,
  };
};

export default useResendOTP;
